import { render, staticRenderFns } from "./CityManagerExpense.vue?vue&type=template&id=88331a1a&scoped=true"
import script from "./CityManagerExpense.vue?vue&type=script&lang=js"
export * from "./CityManagerExpense.vue?vue&type=script&lang=js"
import style0 from "./CityManagerExpense.vue?vue&type=style&index=0&id=88331a1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88331a1a",
  null
  
)

export default component.exports